import { post } from '../Services/http';
import { catchError } from './Error.action';

export const HTTP_ERROR = "HTTP_ERROR"
export const STACKEDPRICESDATA_LOAD = "STACKEDPRICESDATA_LOAD";
export const STACKEDPRICESDATA_LOAD_ERROR = "STACKEDPRICESDATA_LOAD_ERROR";
export const STACKEDPRICESDATA_RECEIVE = "STACKEDPRICESDATA_RECEIVE";
export const STACKEDPRICESDATA_TOGGLE = "STACKEDPRICESDATA_TOGGLE";

export const setstackedprices = (stackedPrice) => (dispatch) => {
    return post('/api/stackedprices', { requestModel: stackedPrice.stackedPrices })
        .then(response => response.json())
        .then(data => dispatch(receive(data))) 
        .catch(ex => dispatch(catchError(ex, error => {
            return loadError(error)
        })));
}
export const loadError = error => ({
    type: STACKEDPRICESDATA_LOAD_ERROR,
    payload: {
        error
    }
});

export const receive = data => ({
    type: STACKEDPRICESDATA_RECEIVE,
    payload: {
        stackedPrices: data
    }
});